const Contact = () =>{
    return (
      <div>
        Contact Us page..
      </div>
    );
}

export default Contact;